import React, { useState, useMemo } from "react";
import PageLoader from "../components/ui/PageLoader";
import { useNavigate } from "react-router-dom";
import "../assets/css/style.css";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Modal from "../components/ui/Modal";
import {
  useAddLogicalPriceMutation,
  useDeleteLogicalPriceMutation,
  useUpdateLogicalPriceMutation,
  useGetLogicalPriceQuery,
} from "apis/logicalPrice";
import { FaPlus } from "react-icons/fa6";
import LogicalPriceEdit from "components/logicalPrice/Edit";
import Button from "components/ui/Button";
import Table from "components/ui/Table";

const LogicalPrice = () => {
  const pageSize = 10;
  const navigate = useNavigate();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const { mutate: updateLogicalPrice } = useUpdateLogicalPriceMutation();
  const {
    data,
    isPending: isLogicalPricePending,
  } = useGetLogicalPriceQuery();
  const { mutate: addLogicalPrice } = useAddLogicalPriceMutation();
  const { mutate: deleteLogicalPrice } = useDeleteLogicalPriceMutation();

  const columns = useMemo(
    () => [
      {
        accessorKey: "index",
        header: "#",
        cell: (_, rowIndex, currentPage) =>
          (currentPage - 1) * pageSize + rowIndex + 1,
        isFilter: false,
        isSortable: false,
      },
      {
        accessorKey: "name",
        header: "Name",
        isFilter: true,
      },
      {
        accessorKey: "percentage",
        header: "Percentage",
        cell: (row) => `${row.percentage}`,
        isFilter: true,
      },
      {
        accessorKey: "actions",
        header: "Actions",
        cell: (row) => (
          <div className="flex items-center space-x-4">
            <button
              onClick={() => {
                setSelectedId(row._id);
                setIsEditOpen(true);
              }}
              className="edit-icon"
              title="Edit"
            >
              <FiEdit2 fontSize={20} />
            </button>
            <button
              onClick={() => {
                setSelectedId(row._id);
                deleteLogicalPrice(row._id);
              }}
              className="delete-icon"
              title="Delete"
            >
              <FiTrash2 fontSize={20} />
            </button>
          </div>
        ),
        isFilter: false,
        isSortable: false,
        stopPropagation: true,
        minWidth: "120px",
      },
    ],
    [navigate] // eslint-disable-line react-hooks/exhaustive-deps
  );

  if (!data) {
    if (isLogicalPricePending) return <PageLoader />;
  }

  const AddLogicalPriceButton = () => (
    <Button
      className="black-button flex items-center"
      onClick={() => setIsAddOpen(true)}
    >
      <FaPlus size={16} className="mr-2" />
      Add
    </Button>
  );

  return (
    <>
      <Modal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        title="Edit"
        className="max-w-2xl"
      >
        <LogicalPriceEdit
          initialName={data?.find((item) => item._id === selectedId)?.name}
          initialPercentage={
            data?.find((item) => item._id === selectedId)?.percentage
          }
          onSubmit={(updatedData) => {
            updateLogicalPrice({ id: selectedId, ...updatedData });
            setIsEditOpen(false);
          }}
        />
      </Modal>

      <Modal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        title="Add"
        className="max-w-2xl"
      >
        <LogicalPriceEdit
          initialName=""
          initialPercentage=""
          onSubmit={(formData) => {
            addLogicalPrice(formData);
            setIsAddOpen(false);
          }}
        />
      </Modal>

      <div className="container mx-auto">
        <Table
          title="Logical Prices"
          columns={columns}
          data={data || []}
          pageSize={pageSize}
          ButtonCmp={AddLogicalPriceButton}
        />
      </div>
    </>
  );
};

export default LogicalPrice;
